import { useEffect } from "react";
import { areSwitchesBootstrapped } from "../../../api/bootstrapApi";
import { planningCalendarApi } from "../../../api/planningCalendarApi";
import { isFeatureOn, setFeatureSwitch, useFeatureSwitchesVersion } from "../../../lib/featureSwitches";

// Release 1.6.0 (O-R72): the SPA's view of planning.calendar.enabled. The menu hides "Calendar" until the server says
// it is on; the server answers 404 anyway while it is off. Checked after sign-in and every ten minutes, so turning the
// governed switch on reaches open tabs without a reload.

export const PLANNING_CALENDAR_FEATURE = "planning.calendar";
const RECHECK_MS = 10 * 60_000;

export async function refreshPlanningCalendarSwitch(): Promise<boolean> {
  try {
    const answer = await planningCalendarApi.availability();
    setFeatureSwitch(PLANNING_CALENDAR_FEATURE, answer.enabled === true);
  } catch {
    // A refusal (no Operations role) or a network blip leaves the switch as it was: off until known.
  }
  return isFeatureOn(PLANNING_CALENDAR_FEATURE);
}

/** Loads the switch while someone with a role is signed in, and re-renders the caller (the shell) when it changes. */
export function usePlanningCalendarSwitch(signedIn: boolean): boolean {
  useFeatureSwitchesVersion();
  useEffect(() => {
    if (!signedIn) return undefined;
    if (!areSwitchesBootstrapped()) {
      void refreshPlanningCalendarSwitch();
    }
    const timer = window.setInterval(() => void refreshPlanningCalendarSwitch(), RECHECK_MS);
    return () => window.clearInterval(timer);
  }, [signedIn]);
  return isFeatureOn(PLANNING_CALENDAR_FEATURE);
}
